import React, {useState} from 'react'
import { ChevronLeft } from 'lucide-react'

const SidebarDisplayButton = ({displaySidebarClick, color="text-gray-600", hoverBgColor="bg-gray-300", tooltipMessage="サイドバーを表示する"}) => {
    const [showTooltip, setShowTooltip] = useState(false);
    return (
        <div className={`absolute left-[80px] top-[10px] rounded-full pointer close z-[5000] ${color}`} onClick={displaySidebarClick} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)} >
            <button
                className={`p-2 rounded-full  hover:${hoverBgColor} focus:outline-none focus:ring-2 focus:ring-gray-300 transition-colors duration-200`}
                aria-label={tooltipMessage}
                >
                <ChevronLeft className="h-5 w-5 transform scale-x-[-1]" />
            </button>
            {showTooltip ? <div className="bg-gray-400 text-white p-2 rounded-lg text-xs absolute top-[40px] w-[120px]">{tooltipMessage}</div> : null}
        </div>
    )
}

export default SidebarDisplayButton